module.exports = __webpack_public_path__ + "static/media/2.6d351ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/hero/2.png
// module id = 376
// module chunks = 0